define([
  "jquery",
  "knockout",
  "globals"
],
function ($, ko, globals) {

  "use strict";

  ko.bindingHandlers.visualizer = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
      var options = ko.unwrap(valueAccessor());

      var enlarge = $(options.zoomable);
      var zoomW = 1.2;
      var zoomH = 1.2;

      if (!globals.isIOS) {
        $(element).on("mouseover", function(e) {
          if (options.url() !== undefined) {
            $(".bdc-visualizer-zoom").css("background-image", 'url(' + ko.unwrap(options.url) + ')');
          var zoomImage = new Image();
          zoomImage.onerror = function () {
            $(".bdc-visualizer-zoom-container").hide();
          };

          zoomImage.onload = function () {
            if (options.url() !== undefined && $($(this)[0]).data("visualizerZoom","true")) {
              $(options.zoomableContainer).fadeIn("fast");
            }
          };
          zoomImage.src = ko.unwrap(options.url);
          }
        });

        $(element).on("mousemove", function(e) {
          if (options.url() !== undefined) {
            var offset = $(this).offset();
            var posleft = offset.left - e.pageX;
            var postop = offset.top - e.pageY;
            postop += 0;
            $(enlarge).css("background-position", ( ( posleft ) * zoomW + 30 ) + "px " + ( ( postop ) * zoomH + 30 ) + "px");
            $(enlarge).css("background-image", "url(" + options.url() + ")");
          }
          
        });

        $(element).on("mouseout", function(e) {
          if (options.url() !== undefined) {
            $(options.zoomableContainer).fadeOut("fast");
          }
        });
      }

    }

  };

});
